import React from "react";
import { usePublisherSessions } from "@seabrookstudios/pitch2table";
import { SessionListItemNoConvention } from "../sessions/SessionListItem";
import { AddSessionDialog } from "../sessions/AddSessionDialog";
import { useMakeListView, useMakeListBuilder, idExtractor } from "../core/useMakeLayout";
import { NoItemsFound } from "../publisher/NoItemsFound";

const NoSessions = () => (
  <NoItemsFound>
    <p>No sessions scheduled with this publisher.</p>
  </NoItemsFound>
);

const SessionListEntry = ({ item }) => {
  return <SessionListItemNoConvention session={item} />;
};

/**
 * Sessions list for a publisher
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId} props.publisherId
 */
export const MySessionsWithPublisher = ({ publisherId }) => {
  const Action = () => <AddSessionDialog seededPublisherIds={[publisherId]} />;

  const useMakeList = useMakeListBuilder(
    SessionListEntry,
    idExtractor,
    "Sessions",
    NoSessions,
    Action,
    undefined,
    undefined
  );

  const useWrappedQuery = () => usePublisherSessions(publisherId);

  const List = useMakeListView(useWrappedQuery, [], "publisher-sessions", useMakeList);

  return <List />;
};
